<template>
    <div>
        <div class="form-row">
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" for="name">Название группы</label><input type="text" class="form-control" :id="'name' + _uid" v-model="name" :class="{ 'is-invalid': form.errors.has('name') }"><has-error :form="form" field="name"/></div>
            <div class="form-group col-xl-4 mb-1">
                <Select2 v-model="platform_id" :options="platform_select" :id="'platform_id' + _uid" :settings="{width: '100%'}"/>
                <has-error :form="form" field="platform_id" class="d-block"/>
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group col-12">
                <button type="button" v-if="mode === 'create'" class="btn btn-primary" @click="create">Создать</button>
                <button type="button" v-if="mode === 'edit'" class="btn btn-primary" @click="update">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "vform";

export default {
    name: "UserGroupForm",
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
        obj: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data: () => ({
        form: new Form({}),
        platform_id: null,
        name: null,
    }),
    mounted() {
        if (this.mode === 'create') {
            if (this.platform_select.length) this.platform_id = this.platform_select[0].id;
            if (this.obj) {
                this.name = this.obj.name;
                this.platform_id = this.obj.platform_id ? this.obj.platform_id : this.platform_id;
            }
        }
        if (this.mode === 'edit' && this.obj) {
            this.name = this.obj.name;
            this.platform_id = this.obj.platform_id;
        }
    },
    computed: {
        platform_select() {
            let options = [];
            let user = this.$store.getters['auth/user'];
            if (user && user.allowed_platforms) {
                user.allowed_platforms.forEach(function (item) {
                    options.push({id: item.id, text: item.name})
                })
            }
            return options;
        },
    },
    methods: {
        validate() {
            this.form = new Form({
                name: this.name,
                platform_id: this.platform_id,
            })
            return true;
        },
        create() {
            let self = this;
            this.validate();
            this.form.post('/api/user_groups')
                .then(response => {
                    self.$emit('created', response.data);
                })
        },
        update() {
            let self = this;
            this.validate();
            this.form.put('/api/user_groups/' + this.obj.id)
                .then(response => {
                    self.$emit('updated', response.data);
                })
        },
    }
}
</script>


<style scoped>

</style>
